<template>
  <div class="item-ppt flex justify-center" v-if="isEnableAddinPowerpoint && !isPresenting">
    <aha-antd-button
      variant="secondary"
      class="mr-2"
      isLoadingInline
      :submitting="loadingAddSlideToPPT"
      :disabled="isDisableEditPresentation"
      @click="addSlideToPowerpoint()"
    >
      Select this slide
    </aha-antd-button>
    <aha-antd-button
      variant="primary"
      isLoadingInline
      :disabled="isDisableEditPresentation"
      :submitting="loadingAddPresentationToPPT"
      @click="addPresentationToPowerpoint()"
    >
      Select presentation
    </aha-antd-button>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import office from '@/services/office'
import config from '@/config'
import Socket from '@/socket'
import constants from '@/constant'
import Utils from '@/util'
import { SET_CURRENT_SLIDE_MODE, FULL_SCREEN_MODE } from '@/vuex/types'

export default {
  data() {
    return {
      loadingAddSlideToPPT: false,
      loadingAddPresentationToPPT: false,
      isEnableAddinPowerpoint: config.isEnableAddinPowerpoint,
    }
  },
  computed: {
    ...mapGetters(['isPresenting']),
    ...mapState({
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
      slideActive: (state) => state.slideActive,
      presentation: (state) => state.presentation,
    }),
  },
  methods: {
    async addSlideToPowerpoint() {
      this.loadingAddSlideToPPT = true
      await office.saveDataToSlidePowerPoint('dataSlidePPT', {
        slideId: this.slideActive.id,
        presentationId: this.presentation.id,
      })
      office.setDataSlideInPowerpointToState(this.presentation.id, this.slideActive.id)
      const payloadSlide = {
        activeSlide: this.slideActive.id,
        socketId: Socket.getSocketId(),
        accessCode: this.presentation.uniqueAccessCode,
        timestamp: new Date().getTime(),
      }
      await this.$http.put(config.api.updateNextSlide + this.presentation.id, payloadSlide)
      const payloadPresenting = {
        presenting: true,
        socketId: Socket.getSocketId(),
        activeSlidePreseting: this.slideActive.id,
        activeSlideAccessCode: this.presentation.uniqueAccessCode,
        presentFromPPT: true,
      }

      await this.$http
        .put(config.api.updatePresentation + this.presentation.id, payloadPresenting)

      this.$store.dispatch(SET_CURRENT_SLIDE_MODE, FULL_SCREEN_MODE)
      this.loadingAddSlideToPPT = false
      const eventAction = 'Add slide to PowerPoint'
      const trackData = {
        eventAction,
        eventCategory: constants.eventCategories.PRESENTATION_EDITOR,
        eventLabel: null,
        presentationId: this.presentation.id,
        slideId: this.slideActive.id,
        slideType: this.slideActive.type,
      }
      Utils.trackGA4AndMixpanel(eventAction, trackData)
    },

    async addPresentationToPowerpoint() {
      this.loadingAddPresentationToPPT = true
      await office.saveDataToSlidePowerPoint('dataSlidePPT', {
        activePresentationId: this.presentation.id,
      })
      office.setDataPresentationInPowerpointToState(this.presentation.id)
      const payloadSlide = {
        activeSlide: this.slideActive.id,
        socketId: Socket.getSocketId(),
        accessCode: this.presentation.uniqueAccessCode,
        timestamp: new Date().getTime(),
      }
      await this.$http.put(config.api.updateNextSlide + this.presentation.id, payloadSlide)
      const payloadPresenting = {
        presenting: true,
        socketId: Socket.getSocketId(),
        activeSlidePreseting: this.slideActive.id,
        activeSlideAccessCode: this.presentation.uniqueAccessCode,
        presentFromPPT: true,
      }

      await this.$http
        .put(config.api.updatePresentation + this.presentation.id, payloadPresenting)

      this.$store.dispatch(SET_CURRENT_SLIDE_MODE, FULL_SCREEN_MODE)
      this.loadingAddPresentationToPPT = false
      const eventAction = 'Add presentation to PowerPoint'
      const trackData = {
        eventAction,
        eventCategory: constants.eventCategories.PRESENTATION_EDITOR,
        eventLabel: null,
        presentationId: this.presentation.id,
      }
      Utils.trackGA4AndMixpanel(eventAction, trackData)
    },
  },
}

</script>
